const PROMOTION_FIELDS = { headline: 'Headline', badge: 'Badge', 'action.label': 'Button label' }

export function inspectionFieldLabel(card, field) {
  return card?.kind === 'promotion' && Object.hasOwn(PROMOTION_FIELDS, field) ? PROMOTION_FIELDS[field] : null
}
